import {
  FiMonitor, FiTruck, FiHeart, FiBook, FiCamera, FiUsers, FiMusic, FiShield, FiWifi, FiAward,
} from 'react-icons/fi';
import { BiAtom, BiDumbbell, BiFoodMenu, BiLibrary } from 'react-icons/bi';

// Curated icon set admins can assign to a facility card. The `key` is what gets
// persisted — both the admin picker and the public FacilitiesSection render off it.
export const ICON_OPTIONS = [
  { key: 'FiMonitor',  label: 'Classroom / Computer', Icon: FiMonitor },
  { key: 'BiAtom',     label: 'Science',              Icon: BiAtom },
  { key: 'BiLibrary',  label: 'Library',              Icon: BiLibrary },
  { key: 'FiBook',     label: 'Books / Reading',      Icon: FiBook },
  { key: 'BiDumbbell', label: 'Sports',               Icon: BiDumbbell },
  { key: 'FiTruck',    label: 'Transportation',       Icon: FiTruck },
  { key: 'BiFoodMenu', label: 'Food / Cafeteria',     Icon: BiFoodMenu },
  { key: 'FiHeart',    label: 'Medical / Health',     Icon: FiHeart },
  { key: 'FiMusic',    label: 'Music',                Icon: FiMusic },
  { key: 'FiCamera',   label: 'Arts / Media',         Icon: FiCamera },
  { key: 'FiUsers',    label: 'Community / Staff',    Icon: FiUsers },
  { key: 'FiShield',   label: 'Security',             Icon: FiShield },
  { key: 'FiWifi',     label: 'Technology',           Icon: FiWifi },
  { key: 'FiAward',    label: 'Achievements',         Icon: FiAward },
];

const ICON_MAP = ICON_OPTIONS.reduce((map, opt) => { map[opt.key] = opt.Icon; return map; }, {});
export const getFacilityIcon = (key) => ICON_MAP[key] || FiMonitor;

// Curated color set. `card` styles the card's icon chip; `swatch` is a solid dot for the picker.
export const COLOR_OPTIONS = [
  { key: 'primary',   label: 'Primary Blue',   card: 'bg-primary-50 text-primary-600 border-primary-100',     swatch: 'bg-primary-400' },
  { key: 'secondary', label: 'Secondary Teal', card: 'bg-secondary-50 text-secondary-600 border-secondary-100', swatch: 'bg-secondary-400' },
  { key: 'blue',      label: 'Blue',           card: 'bg-blue-50 text-blue-600 border-blue-100',               swatch: 'bg-blue-400' },
  { key: 'indigo',    label: 'Indigo',         card: 'bg-indigo-50 text-indigo-600 border-indigo-100',         swatch: 'bg-indigo-400' },
  { key: 'orange',    label: 'Orange',         card: 'bg-orange-50 text-orange-600 border-orange-100',         swatch: 'bg-orange-400' },
  { key: 'pink',      label: 'Pink',           card: 'bg-pink-50 text-pink-600 border-pink-100',               swatch: 'bg-pink-400' },
  { key: 'green',     label: 'Green',          card: 'bg-green-50 text-green-600 border-green-100',            swatch: 'bg-green-400' },
  { key: 'purple',    label: 'Purple',         card: 'bg-purple-50 text-purple-600 border-purple-100',         swatch: 'bg-purple-400' },
];

const COLOR_MAP = COLOR_OPTIONS.reduce((map, opt) => { map[opt.key] = opt; return map; }, {});
export const getFacilityColorClasses = (key) => (COLOR_MAP[key] || COLOR_MAP.primary).card;
